import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BuildingListing, TourbookSummary } from '@root/types';
import { some } from 'lodash';
import s from './AvailableSpaces.module.less';
import TableRow from './TableRow';

type Props = {
  listings: BuildingListing[];
  buildingSlug: string;
  listingClicked: (listing: BuildingListing, tab: string) => void;
  tourbooks: TourbookSummary[];
  isUserLoggedIn: boolean;
  tabSelectedForAnalytics: string;
};
const AvailableSpacesFullTable = ({
  listings,
  buildingSlug,
  listingClicked,
  tourbooks,
  isUserLoggedIn,
  tabSelectedForAnalytics,
}: Props) => {
  const { t } = useTranslation('building');

  const isInTourbook = (listingId: string): boolean =>
    some(tourbooks, tourbook => tourbook.listingIds.includes(listingId));

  return (
    <div className={s.availableSpacesTable}>
      <div className={s.table}>
        <ul className={s.header}>
          <li className={cn(s.cell, s.unitHeader)}>{t('availableSpaces.headers.unit')}</li>
          <li className={s.cell}>{t('availableSpaces.headers.size')}</li>
          <li className={cn(s.cell, s.availableHeader)}>
            {t('availableSpaces.headers.available')}
          </li>
          <li className={cn(s.desktopOnly, s.cell)}>
            {t('availableSpaces.headers.spaceCondition')}
          </li>
          {isUserLoggedIn && (
            <li className={cn(s.cell, s.leaseTypeHeader)}>
              {t('availableSpaces.headers.leaseType')}
            </li>
          )}
          <li className={cn(s.desktopOnly, s.cell)}>{t('availableSpaces.headers.furnished')}</li>
          <li className={cn(s.desktopOnly, s.cell)}>{t('availableSpaces.headers.price')}</li>
          <li className={cn(s.cell, s.floorPlanHeader)}>
            {t('availableSpaces.headers.floorPlan')}
          </li>
        </ul>
        <div className={s.tbody}>
          <div className={s.headerSpacer} />
          {listings.map(listing => (
            <TableRow
              listing={listing}
              buildingSlug={buildingSlug}
              onClick={() => listingClicked(listing, tabSelectedForAnalytics)}
              isInTourbook={isInTourbook(listing.id)}
              tourbooks={tourbooks}
              key={listing.id}
              isUserLoggedIn={isUserLoggedIn}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvailableSpacesFullTable;
